import React from 'react';
import {connect} from "react-redux";

import * as AdminActions from "../../../../actions/admin";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class SeasonMemberStats extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            club: this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? this.props.auth.currentEntity : '',
            pigeonhole: '',
            allPigeons: true,
            onlyDdB: false,
            onlySection: false,
            order: 'race',
        });
    }

    componentDidMount() {
        if (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));
        else if (!this.props.admin.isClubsRead) this.props.dispatch(AdminActions.getClubs());
    }

    fields = [];
    render() {
        return <div className="season-member-stats reports-inner-box report-options">
            <table>
                <tbody>
                    <tr>
                        {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <td style={{width: '100px'}}><label htmlFor="club">Forening</label></td>}
                        <td>
                            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'-- Vælg --'} className="field100p" containerClassName="display-inline-block field100p"
                                              name="club" id="club" value={this.state.club} options={
                                                  this.props.admin.clubs ? this.props.admin.clubs.filter(c => (
                                                      (c.Sektionsnr !== '99' && (this.props.auth.currentRole !== UserRoles.SECTION_ADMIN.id || c.Sektionsnr === this.props.auth.currentEntity))
                                                  )).sort((c1, c2) => c1.Foreningsnr < c2.Foreningsnr ? -1 : (c1.Foreningsnr > c2.Foreningsnr ? 1 : 0)).map(club => (
                                                      {key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn)}
                                                  )).toArray() : []
                                              }
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={e => {
                                                  this.setState({club: e.target.value, pigeonhole: ''});
                                                  this.props.dispatch(AdminActions.getClub(e.target.value));
                                              }}
                                              ref={instance => { this.fields[0] = instance; }}
                            />}
                        </td>
                    </tr>
                    <tr>
                        <td style={{width: '100px'}}><label className={this.state.club === '' ? 'disabled' : ''} htmlFor="pigeonhole">Slag</label></td>
                        <td>
                            <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'-- Vælg --'} className="field100p" containerClassName="display-inline-block field100p" disabled={this.state.club === ''}
                                              name="pigeonhole" id="pigeonhole" value={this.state.pigeonhole} options={
                                                  this.props.admin.pigeonHoles ? this.props.admin.pigeonHoles.filter(p => p.Foreningsnr === this.state.club).sort((p1, p2) => p1.Slagnr < p2.Slagnr ? -1 : (p1.Slagnr > p2.Slagnr ? 1 : 0)).map(pigeonHole => (
                                                      {key: pigeonHole.Slagnr, value: pigeonHole.Slagnr + (pigeonHole.Slagnavn === null ? '' : ' - ' + pigeonHole.Slagnavn)}
                                                  )).toArray() : []
                                              }
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[1] = instance; }}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="options-separator"/>
            <div className="options-group">
                <input id="allPigeons" name="allPigeons" type="checkbox" checked={this.state.allPigeons} onClick={e => this.setState({allPigeons: !this.state.allPigeons})}/> <label htmlFor="allPigeons">Alle duer</label>
            </div>
            <div className="options-separator"/>
            <div className="options-group">
                <input id="onlyDdB" name="onlyDdB" type="checkbox" checked={this.state.onlyDdB} onClick={e => this.setState({onlyDdB: !this.state.onlyDdB, onlySection: !this.state.onlyDdB ? false : this.state.onlySection})}/> <label htmlFor="onlyDdB">Kun DdB-flyvninger</label>
            </div>
            <div className="options-group">
                <input id="onlySection" name="onlySection" type="checkbox" checked={this.state.onlySection} onClick={e => this.setState({onlySection: !this.state.onlySection, onlyDdB: !this.state.onlySection ? false : this.state.onlyDdB})}/> <label htmlFor="onlySection">Kun sektionsflyvninger</label>
            </div>
            <div className="options-separator"/>
            <div className="options-group">
                <input id="orderRace" name="order" type="radio" checked={this.state.order === 'race'} onClick={e => this.setState({order: 'race'})}/> <label htmlFor="orderRace">Sorter efter uge/kapflyvning</label>
            </div>
            <div className="options-group">
                <input id="orderPigeon" name="order" type="radio" checked={this.state.order === 'pigeon'} onClick={e => this.setState({order: 'pigeon'})}/>< label htmlFor="orderPigeon">Sorter efter ringnummer</label>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        const options = {
            club: this.state.club === '' ? null : this.state.club,
            pigeonhole: this.state.pigeonhole === '' ? null : this.state.pigeonhole,
            allPigeons: this.state.allPigeons,
            onlyDdB: this.state.onlyDdB,
            onlySection: this.state.onlySection,
            order: this.state.order,
        };

        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        isClubsRead: state.admin.isClubsRead,
        clubs: state.admin.clubs,
        pigeonHoles: state.admin.pigeonHoles,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(SeasonMemberStats);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/SeasonMemberStats.js